module.exports = __webpack_public_path__ + "static/media/logo.d82bdddf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 2189
// module chunks = 0